import React, { useState } from "react";
//import { Link } from 'react-router-dom'
import { createRole } from "../../../../src/service/ApiServices";

const AddRole = () => {
  const [roleName, setRoleName] = useState("");
  // const [functions, setFunctions] = useState([{
  //   functionId: "",
  //   permissions: {
  //     create: false,
  //     edit: false,
  //     delete: false,
  //     view: false,
  //     search: false,
  //     download: false,
  //     upload: false,
  //     approve: false,
  //     reject: false,
  //     print: false,
  //     reprint: false
  //   }
  // }]);

  {
    /*
    const handleGetRoles = async () => {
      try {
        const rolesData = await getRoles();
        setRoles(rolesData);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };
    console.log(roles, "Updated Roles addrole.jsx");
  */
  }

  const handleCreateRole = async () => {
    try {
      const response = await createRole(roleName);
      console.log("Role created:", response);
      setRoleName("");
      // setFunctions([{
      //   functionId: "",
      //   permissions: {
      //     create: false,
      //     edit: false,
      //     delete: false,
      //     view: false,
      //     search: false,
      //     download: false,
      //     upload: false,
      //     approve: false,
      //     reject: false,
      //     print: false,
      //     reprint: false
      //   }
      // }]);
    } catch (error) {
      console.error("Error creating role:", error);
    }
  };

  // const handlePermissionChange = (index, permission) => {
  //   const newFunctions = [...functions];
  //   newFunctions[index].permissions[permission] = !newFunctions[index].permissions[permission];
  //   setFunctions(newFunctions);
  // };

  return (
    <div>
      {/* Add Role */}
      <div className="modal fade" id="add-units" data-bs-backdrop="static" data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Create Role</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form>
                    <div className="mb-3">
                      <label className="form-label">Role Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={roleName}
                        onChange={(e) => setRoleName(e.target.value)}
                      />
                    </div>
                    
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      
                      <button
                        type="button"
                        className="btn btn-submit"
                        data-bs-dismiss="modal"
                        onClick={handleCreateRole}
                      >
                        Create Role
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Role */}
    </div>
  );
};

export default AddRole;
